import styles from './styles.module.css';

export default function MethodsLcaTool({ dict }) {
    const {
        methods_lca_tool_1,
        methods_lca_tool_2
    } = dict.discover;

    return (
        <section className={styles.methods_lca_tool}>
            <p>{methods_lca_tool_1}</p>
            <p>{methods_lca_tool_2}</p>
        </section>
    );
}
